import React, { CSSProperties } from 'react';
import LoadingGif from './loading.gif';

interface AryaLoadingProps {
  containerStyles?: CSSProperties;
  imageStyles?: CSSProperties;
}

const AryaLoading = ({
  containerStyles = {
    top: '50%',
    left: '50%',
    position: 'absolute',
    transform: 'translate(-50%, -50%)',
  },
  imageStyles = {},
}: AryaLoadingProps) => {
  return (
    <div style={{ ...containerStyles }}>
      <img src={LoadingGif} alt="Loading..." style={{ width: '100px', height: '100px', ...imageStyles }} />
    </div>
  );
};

export default AryaLoading;
